import * as api from "../api/index";
import {
  CREATE_CASH_TRANSACTION,
  FETCH_CASH_TRANSACTIONS,
  CLOSE_REGISTER,
  FETCH_CASH_SUMMARY,
  START_LOADING,
  END_LOADING,
} from "./constants";

export const createCashTransaction = (transaction, callback) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.createCashTransaction(transaction);
    dispatch({ type: CREATE_CASH_TRANSACTION, payload: data });
    callback(true);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message);
  }
};



export const fetchCashTransactions = (startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchCashTransactions(startDate, endDate);
      console.log('Action: Fetched transactions:', data);
      dispatch({ type: FETCH_CASH_TRANSACTIONS, payload: data });
      dispatch({ type: END_LOADING });
      return { payload: data }; // Return for promise handling
    } catch (error) {
      console.error('Action: Error fetching transactions:', error);
    }
  };

export const closeRegister = (data, callback) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data: result } = await api.closeRegister(data);
    dispatch({ type: CLOSE_REGISTER, payload: result });
    callback(true);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message);
  }
};

export const fetchCashSummary = (date) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCashSummary(date);
    dispatch({ type: FETCH_CASH_SUMMARY, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const generateDailyReport = (date) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCashSummary(date);
    const { data: transactions } = await api.fetchCashTransactions(date, date);
    
    const reportData = {
      ...data,
      transactions,
    };
    
    dispatch({ type: END_LOADING });
    return { data: reportData };
  } catch (error) {
    console.error('Error generating report:', error);
    dispatch({ type: END_LOADING });
    throw error;
  }
};